<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>reviews.update-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <form *ngIf="company || !review.company_id">
        <label for="company" translate>reviews.update-popup.form.company.label</label>
        <div class="form-group vox-input-group_dense">
          <gdp-company-search [formControl]="companyFormControl"></gdp-company-search>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" (click)="assignCompany()" [ladda]="loading" data-spinner-color="grey"
            data-style="zoom-in" type="submit">
            <span translate>reviews.update-popup.form.submit.update</span>
          </button>
        </div>
      </form>
      <div *ngIf="!company && review.company_id">
        <ngx-skeleton-loader [theme]="{'height':'144px'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>